<template>
  <div class="content content-wrapper">
    <PayfastLoader v-if="hasPFTheme" :instruction="instruction" />
    <SidLoader v-else :instruction="instruction" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { isStringSet } from '@/utils'
import PayfastLoader from '@/components/Loaders/PayfastLoader.vue'
import SidLoader from '@/components/Loaders/SidLoader.vue'

export default {
  name: 'Loading',
  components: { SidLoader, PayfastLoader },
  props: {
    instruction: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapState('transaction', ['transaction']),
    hasPFTheme() {
      return (
        isStringSet(this.transaction.theme) && this.transaction.theme == 'PF'
      )
    },
  },
}
</script>

<style scoped lang="scss">
.content {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
</style>
